import { Button } from "@sellar-io/components";
import { ReactElement } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useEvents } from "../../../hooks";
import { useOrderIncompleteStripePaymentMarkAsPaid } from "../../../hooks/api/v2/order/useOrderIncompleteStripePaymentMarkAsPaid";

export function IncompleteStripePaymentOrderPaidModal({
  active,
  onDismiss,
  orderId,
}: {
  active: boolean;
  onDismiss: () => void;
  orderId: number;
}): ReactElement {
  const { track } = useEvents();

  const mutation = useOrderIncompleteStripePaymentMarkAsPaid(orderId);

  const onConfirm = async () => {
    const paidAt = new Date();
    mutation.mutate(undefined, {
      onSuccess: () => {
        track("Order Marked As Paid", {
          initiator: "supplier",
          orderId: orderId,
          paidAt,
        });
        onDismiss();
      },
    });
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title="Mark this order as paid"
        description="Completing this action will mark the order as paid. This cannot be undone and will cancel the payment on Stripe."
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={onDismiss}
      />
      <DialogCTA>
        <Button onClick={onConfirm} loading={mutation.isPending}>
          Order paid
        </Button>
      </DialogCTA>
    </Dialog>
  );
}
